/**
 * 格式化IOS系统下时间
 * @param formatIOSDateStr
 * @returns
 */
export function formatIOSDateStr(inputDateStr: string) {
  const dateStr = inputDateStr;
  // 需要检查格式，可能会输出这种格式日期'Friday, 08-Oct-2021 08:05:24 GMT';
  if (/^\d{4}-\d{1,2}-\d{1,2}/.test(dateStr)) {
    return dateStr.replace(/-/g, '/');
  }
  return dateStr;
}

/**
 * 获取当周开始和结束时间
 * @param currentDate 当前时间
 * @returns
 */
export function getWeekDate(currentDate?: Date) {
  const now = currentDate || new Date();
  const nowTime = now.getTime();
  const day = now.getDay() === 0 ? 7 : now.getDay();
  const oneDayTime = 24 * 60 * 60 * 1000;
  const monday = new Date(nowTime - ((day - 1) * oneDayTime)); // 周一
  const sunday = new Date(nowTime + ((7 - day) * oneDayTime)); // 周日
  return {
    startTime: new Date(monday.getFullYear(), monday.getMonth(), monday.getDate()), // 周一 0:0:0
    endTime: new Date(sunday.getFullYear(), sunday.getMonth(), sunday.getDate(), 23, 59, 59), // 周日：23:59:59秒
  };
}

/**
 * 获取倒计时 - 天时分秒
 * @param distance 时间戳差值
 * @returns
 */
export function getCountdownVal(distance: number) {
  const fDistance = distance < 0 ? 0 : distance;

  return {
    day: Math.floor(fDistance / (1000 * 60 * 60 * 24)),
    hours: Math.floor((fDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((fDistance % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((fDistance % (1000 * 60)) / 1000),
  };
}

/**
 * 对小于10的数补全前置0
 * @param val
 * @returns
 */
export function patchZero(val: string | number) {
  return +val < 10 ? `0${val}` : val;
}

/**
 * 检查时间
 * @param startDate 开始
 * @param endDate 结束
 * @param now 当前时间
 */
export function checkDate(start: Date, end: Date, now: Date) {
  const nowTime = now.getTime();
  const startTime = start.getTime();
  const endTime = end.getTime();

  if (nowTime >= startTime && nowTime <= endTime) {
    // 之间
    return 'between';
  }
  if (nowTime < startTime) {
    // 之前
    return 'before';
  }
  if (nowTime > endTime) {
    // 之后
    return 'after';
  }
}
